"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BomExportedEvent = exports.ProjectModelIngestedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
exports.ProjectModelIngestedEvent = (0, event_1.createEventClass)('ProjectModelIngestedEvent', zod_1.z.object({
    projectModelId: zod_1.z.string(),
    projectId: zod_1.z.string(),
    buildId: zod_1.z.string(),
    componentCount: zod_1.z.number(),
    moduleCount: zod_1.z.number(),
}));
exports.BomExportedEvent = (0, event_1.createEventClass)('BomExportedEvent', zod_1.z.object({
    projectModelId: zod_1.z.string(),
    projectId: zod_1.z.string(),
    bomItemCount: zod_1.z.number(),
    resolvedAsPackageCount: zod_1.z.number(),
    packageMissingDatasheetCount: zod_1.z.number(),
}));
//# sourceMappingURL=ingestion-events.js.map